/**
 * Modal Constants
 * @type {string}
 */

export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'

export const modalType = {
  CONTACT_FORM: 'CONTACT_FORM',
  GDPR_WARNING: 'GDPR_WARNING'
}

/**
 * Open Modal
 * @param params
 * @param params.type - modal type
 * @param params.component - render component
 * @param params.props - component props
 */
export const _openModal = (params = {}) => ({
  type: OPEN_MODAL,
  payload: params
})

/**
 * Close Modal
 */
export const _closeModal = () => ({
  type: CLOSE_MODAL
})

/**
 * Dispatch OPEN_MODAL
 * @param params
 * @param params.type - modal type
 * @param params.component - render component
 * @param params.props - component props
 */
export const openModal = (params) => (dispatch) => {
  return dispatch(_openModal(params))
}

/**
 * Close Modal
 */
export const closeModal = () => (dispatch) => {
  return dispatch(_closeModal())
}
